/**
 * Description: reservation接口
 * Author: zhengy
 * Date: 2019-06-25
 * Time: 17:05
 */

export const reservationApiMap = {
  //获取带分页的预约部门数据
  findOrderData: '/reservation/v1/page',
  //获取预约申请主信息
  findOrderMain: 'reservation/v1/ordermain/',
  //获取带分页的预约事项集合数据  v1/{dept_id}/matter/page
  findOrderMatItem: 'reservation/v1',
  //我的预约
  getmypage: '/reservation/v1/myorder/page/list',
  // 提交预约信息
  createOrderInfo: 'reservation/v1/orderinfo',
  // 提交预约信息无验证码
  createOrderInfoNoCode: 'reservation/v1/orderinfonocode',
  //撤销预约
  deleteAtt: 'reservation/v1/myorder/',
  //获取预约详情
  getReservastionDetailByID: 'reservation/v1/details/',


  //获取预约的天数,根据预约配置判断
  getOrderDaysV2: 'reservation/newversion/v1/getOrderDaysV2',
  //获取带分页的预约部门数据V2
  findOrderDataV2: 'reservation/newversion/v1/page',
  //获取带分页的预约部门数据
  findOrderTimeData: 'reservation/newversion/v1/timeList/page',
  //获取预约日期
  getReservationDate:'reservation/hubei/self/date',
  //提交表单
  submitData:'reservation/hubei/self/family',
  //获取律师信息
  queryLawyer:'reservation/hubei/lawyer',
  //预约表单提交
  selfOrderLawyer:'reservation/hubei/self/lawyer',
  //提交定制化预约 办案事项
  handleMatter: 'reservation/hubei/self/handle',

}
